
    // this file was auto generated by python script
    import UserPlus from './UserPlus';
    export default UserPlus;
    